import type fr from '../fr/employee';

const en: typeof fr = {
  nav: { title: 'My work', today: 'Today', calendar: 'Calendar', history: 'History', payroll: 'Pay', messages: 'Messages', profile: 'Profile' },
  common: {
    myPay: 'Employee amount',
    estimated: 'Estimated time',
    pets: 'Pets',
    petsOnSite: 'Pets on site',
    view: 'View',
    directions: 'Directions',
    previousDay: 'Previous day',
    nextDay: 'Next day',
    previousWeek: 'Previous week',
    nextWeek: 'Next week',
    thisWeek: 'This week',
    priority: '{{priority}} priority',
    jobNumber: 'Job #{{number}}',
  },
  today: {
    hello: 'Hello {{name}}',
    count_zero: 'No cleaning that day',
    count_one: '{{count}} cleaning today',
    count_other: '{{count}} cleanings today',
    countOther_one: '{{count}} cleaning',
    countOther_other: '{{count}} cleanings',
    dayOff: 'Day off',
    dayOffHint: 'No cleaning scheduled that day. Enjoy!',
    seeCalendar: 'See my calendar',
    route: 'Suggested order',
    routeTotal: '{{km}} km · {{minutes}} min of driving in total',
    travel: '{{minutes}} min drive',
    late: 'May be {{minutes}} min late',
    noCoordinates: 'Address not located',
  },
  job: {
    title: 'Cleaning',
    important: 'Important',
    priority: 'Priority',
    parking: 'Parking',
    instructions: 'Special instructions',
    permanentNotes: 'Permanent notes',
    forbiddenAreas: 'Off-limits areas',
    preferences: 'Client preferences',
    specialProducts: 'Special products',
    nothingImportant: 'No special instructions.',
    access: 'Access',
    showAccess: 'Show access info',
    hideAccess: 'Hide access info',
    accessHint: 'Confidential: every view is logged.',
    noAccess: 'No access information on file.',
    property: 'Property',
    propertySummary: '{{bedrooms}} bd · {{bathrooms}} ba · {{floors}} floor(s)',
    team: 'Team',
    checklist: 'Checklist',
    progress: '{{done}} / {{total}} tasks',
    checklistLocked: 'Start the cleaning to check off tasks.',
    noTasks: 'No tasks for this cleaning.',
    optionalTask: 'optional',
    action: {
      CONFIRMED: 'Confirm',
      EN_ROUTE: 'I’m on my way',
      ARRIVED: 'I’ve arrived',
      IN_PROGRESS: 'Start cleaning',
      COMPLETED: 'Finish cleaning',
    },
    statusDone: {
      CONFIRMED: 'Cleaning confirmed.',
      EN_ROUTE: 'Drive safely!',
      ARRIVED: 'Arrival recorded.',
      IN_PROGRESS: 'Cleaning started.',
      COMPLETED: 'Cleaning finished.',
    },
    finishTitle: 'Finish this cleaning?',
    finishDescription: 'Make sure every task is done before finishing.',
    finishNotes: 'Closing notes (optional)',
    finishNotesPlaceholder: 'E.g. product to restock, broken item, note for the office…',
    finishConfirm: 'Finish',
    missingTitle: 'Required tasks not checked',
    missingHint: 'Check these tasks before finishing, or message the office if there is a problem.',
    completedTitle: 'Well done, cleaning finished!',
    completedHint: 'Thank you for your work. The office has been notified.',
    backToday: 'Back to my day',
    reviewRequired: 'The office will review this cleaning.',
    cancelled: 'This cleaning was cancelled.',
    writeOffice: 'Message the office',
  },
  calendar: {
    title: 'Calendar',
    week: 'Week of {{date}}',
    free: 'Free',
    empty: 'No cleaning this week.',
  },
  history: {
    title: 'History',
    subtitle: 'Your completed cleanings',
    empty: 'No completed cleaning in this period.',
    range: {
      '30': 'Last 30 days',
      '90': 'Last 3 months',
      '365': 'Last 12 months',
    },
    rangeLabel: 'Period',
    totals: '{{count}} cleaning(s) · {{amount}}',
  },
  payroll: {
    title: 'Pay',
    subtitle: 'Amounts calculated from your completed cleanings.',
    week: 'This week',
    period: 'Pay period',
    periodRange: 'From {{from}} to {{to}}',
    pending: 'Pending',
    pendingHint: 'Awaiting office approval',
    approved: 'Approved',
    approvedHint: 'Will be paid on the next payday',
    entries: 'Details',
    empty: 'No pay entries yet.',
    emptyHint: 'Your amounts will appear here after each completed cleaning.',
    entryMinutes: '{{minutes}}',
  },
  messages: {
    title: 'Messages',
    subtitle: 'Write to the office with any question.',
    new: 'New message',
    newDescription: 'Your message will be sent to the office.',
    subject: 'Subject (optional)',
    body: 'Message',
    send: 'Send',
    selectHint: 'Choose a conversation.',
    back: 'All conversations',
    sent: 'Message sent.',
  },
  profile: {
    title: 'My profile',
    contact: 'Contact information',
    vehicle: 'Vehicle',
    hasVehicle: 'Yes',
    noVehicle: 'No',
    skills: 'Skills',
    sectors: 'Areas',
    teams: 'Teams',
    availability: 'Usual availability',
    availabilityHint: 'To change it, message the office.',
    unavailable: 'Not available',
    timeOff: 'Planned time off',
    noTimeOff: 'No planned time off.',
    declare: 'Report an absence',
    startDate: 'From',
    endDate: 'To',
    reason: 'Reason (optional)',
    submit: 'Send request',
    declared: 'Absence recorded. The office has been informed.',
    invalidRange: 'The end date must be after the start date.',
    language: 'Language',
    skill: {
      STANDARD: 'Standard cleaning',
      DEEP: 'Deep cleaning',
      PETS_OK: 'Comfortable with pets',
      MOVE: 'Move in/out',
      COMMERCIAL: 'Commercial',
      WINDOWS: 'Windows',
    },
  },
};
export default en;
